import { IconButton } from '@mui/material'
import Snackbar from '@mui/material/Snackbar'
import React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'app/reducers'
import { resetSnackbar } from './action'

function SnackbarComponent() {
  const dispatch = useDispatch()
  const snackbarInfo = useSelector((state: RootState) => state.SnackbarInfo)
  const handleCloseSnackbar = () => {
    dispatch(resetSnackbar())
  }

  React.useEffect(() => {
    if (snackbarInfo.open) {
      setTimeout(function () {
        dispatch(resetSnackbar())
      }, 5000)
    }
  }, [snackbarInfo])

  const closeSnackbarIcon = (
    <React.Fragment>
      <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnackbar}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  )
  return (
    <>
      <Snackbar
        className="snackBar"
        open={snackbarInfo.open}
        autoHideDuration={5000}
        message={snackbarInfo.message}
        onClose={handleCloseSnackbar}
        action={closeSnackbarIcon}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </>
  )
}

export default SnackbarComponent
